
import { getLogList } from '@/api/admin'
import { delObjEmptyKey } from '@/utils'
import { dateToSeconds, pickerOptions, getCurrentDate } from '@/utils/dateTime'
import { Component, Vue, Watch } from 'vue-property-decorator'
import pagination from '@/components/Pagination/index.vue'
import { AppModule } from '@/store/modules/app'
@Component({
  name: 'log',
  components: {
    pagination
  }
})
export default class extends Vue {
  private listLoading: boolean = true
  private listQuery = {
    page: 1,
    limit: 20
  }
  private queryForm: any = {
    created_by_name: '',
    description: '',
    start_time: null,
    end_time: null
  }
  private list: any[] = []
  private total = 0
  private date: any[] = getCurrentDate()
  private pickerOptions = pickerOptions

  // 分页器设置
  private pagesize: number = 20
  private handleSizeChange (size) {
    this.pagesize = size
    this.hadleGetFilesListApi()
  }

  // 分页切换
  private currentPage: number = 1
  private handleCurrentChange (currentPage) {
    this.currentPage = currentPage
    this.hadleGetFilesListApi()
  }

  // 对所有数据进行分页处理 发送请求
  private async hadleGetFilesListApi () {
    try {
      this.listLoading = true
      const data = {
        ...this.queryForm,
        page_size: this.pagesize,
        page: this.currentPage
      }
      delObjEmptyKey(data)
      await getLogList(data).then((res: any) => {
        this.list = res.results
        this.total = res.count
        this.listLoading = false
      })
    } catch (e) {
      this.listLoading = false
    }
  }

  // 创建时间监听
  @Watch('date', { immediate: true })
  private pickerChange () {
    if (this.date) {
      this.queryForm.start_time = dateToSeconds(this.date[0])
      this.queryForm.end_time = dateToSeconds(this.date[1])
    } else {
      this.queryForm.start_time = null
      this.queryForm.end_time = null
    }
  }

  private select () {
    this.currentPage = 1
    this.hadleGetFilesListApi()
  }

  private reset () {
    this.queryForm = {
      created_by_name: '',
      description: '',
      start_time: null,
      end_time: null
    }
    this.date = getCurrentDate()
    this.currentPage = 1
    // this.getLog(true)
    this.hadleGetFilesListApi()
  }

  private async getLog (isReset: boolean) {
    if (isReset) {
      this.listQuery.page = 1
    }
    this.listLoading = true
    try {
      const data: any = {
        ...this.queryForm,
        page: this.listQuery.page
      }
      delObjEmptyKey(data)
      await getLogList(data).then((res: any) => {
        this.list = res.results
        this.total = res.count
        this.listLoading = false
      })
    } catch (e) {
      this.listLoading = false
    }
  }

  private siteName = this.$store.state.app.enterprise.ssl_switch.site_name
  private systemName: any = 'Admin System'
  private sitelogo: any = this.$store.state.app.enterprise.ssl_switch.site_logo
  private systemLogo: any = ''

  mounted () {
    // this.getLog(true)
    this.hadleGetFilesListApi()
    if (this.siteName && this.siteName !== '') {
      AppModule.SetSiteName(this.siteName)
      document.title = this.siteName + ' ' + this.$t(`route.operation`)
    } else {
      AppModule.SetSiteName(this.systemName)
      document.title = this.$t(`route.log`) + '- Admin System'
    }
    if (this.sitelogo && this.sitelogo !== '') {
      AppModule.SetSiteLogo(this.sitelogo)
      let link: any =
        document.querySelector("link[rel*='icon']") ||
        document.createElement('link')
      link.type = 'image/x-icon'
      link.rel = 'shortcut icon'
      link.href = this.sitelogo
      document.getElementsByTagName('head')[0].appendChild(link)
    } else {
      AppModule.SetSiteLogo(this.systemLogo)
      let link: any =
        document.querySelector("link[rel*='icon']") ||
        document.createElement('link')
      link.type = 'image/x-icon'
      link.rel = 'shortcut icon'
      link.href = this.systemLogo
      document.getElementsByTagName('head')[0].appendChild(link)
    }
  }
}
